/**
 * Available sort options for searching events.
 * */

export const sortingCategories = {
  RECOMMENDED: 'recommended',
  DATE: 'date',
  PRICE: 'price',
};

export const defaultSort = `${sortingCategories.RECOMMENDED}-0`;
